<template>
  <div>
    <v-row>
      <v-col md="12">
        <v-autocomplete
          class="mb-n2"
          label="Seleccione la temporada donde se replicara la tarifa"
          :items="temporadas"
          v-model="Temporada"
          :error-messages="(errors.temporada)?errors.temporada:''"
          item-value="id"
          item-text="NombreCompleto"
        >
        </v-autocomplete>
      </v-col> 

      <v-col md="12">
        <v-btn block @click="checkForm()" color="green" dark> Replicar </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ReplyTarifa",
  components: {

  },
  props: ["edit", "dataEdit", "temporadas", "subCate", "accessArray"],
  data() {
    return {
        reply:true,
      defaultColor:true,
      Color:"#4895f5",
      modelColor:"4895f5",
      Id: "",
      Turista:false,
      Tarifario: "",
      Temporada: "",
      subcategoria: [],
      cateTarifa:'',
      MainDepartamento: "",
      Precios: {},
      accesos: [],
      PreciosList: [],
      tiposJuego: [],
      selectedTemporada: "",
      Horarios: [],
      tipoJuego: "",
      Horario: "",
      HoraInicial: "",
      HoraFinal: "",
      days: {
        dom: true,
        lun: true,
        mar:true,
        mie: true,
        jue: true,
        vie: true,
        sab: true,
      },
      minDate: "06:00",
      maxDate: "18:00",
      moneda: "USD",
      precio: "",
      precioContable: "",
      errors: {},
    };
  },
  methods: {
    onSelectColor(){
      
      this.Color = this.modelColor || this.modelColor
    },
    deletePrecio(dias, idModalidad, idHorario) {
      delete this.Precios[dias][idModalidad][idHorario];
      this.PreciosList = this.generateListPrecio();
      this.$forceUpdate();
    },
    changePrecio(dias, idModalidad, idHorario, precio,moneda) {
      this.Precios[dias][idModalidad][idHorario].PcoCon = Number(precio)
      this.Precios[dias][idModalidad][idHorario].PcoVen = Number(precio)
      this.Precios[dias][idModalidad][idHorario].Moneda = moneda
      this.PreciosList = this.generateListPrecio();
      this.$forceUpdate();
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("RVA/Tarifas/" + this.MainDepartamento + "/Horarios")

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function (element) {
        $this.Horarios.push({
          id: element[0],
          NombreCompleto:
            element[1].Nombre +
            " : " +
            element[1].HoraInicio +
            " - " +
            element[1].HoraTermino,
          ...element[1],
        });
      });
    },
    addPrecio() {
      let valid = true;
      this.errors = [];

      if (!this.tipoJuego) {
        this.errors.tjuego = "El tipo de juego es obligatorio";
        valid = false;
      } else {
        this.errors.tjuego = false;
      }

      let daysSelected = Object.entries(this.days);
      let daysIsSelected = false;
      daysSelected.forEach((day, index) => {
        if (day[1]) {
          daysIsSelected = true;
        }
      });

      if (!daysIsSelected) {
        this.errors.days = "Los dias de la tarifa es requerido";
        valid = false;
      } else {
        this.errors.days = false;
      }
      if (!this.precio) {
        this.errors.precio = "El precio de la tarifa es requerido";
        valid = false;
      } else {
        this.errors.precio = false;
      }
      if (!this.precioContable) {
        this.errors.precioContable =
          "El precio contable de la tarifa es requerido";
        valid = false;
      } else {
        this.errors.precioContable = false;
      }
      if (!this.Horario) {
        this.errors.horario = "El horario es requerido";
        valid = false;
      } else {
        this.errors.horario = false;
      }

      let days = Object.entries(this.days);
      let arrayDays = [];
      days.forEach((day, index) => {
        if (day[1]) {
          arrayDays.push(index);
        }
      });

      if (valid) {
        let validHour = this.validateHorarios(
          this.tipoJuego,
          this.Horario,
          arrayDays
        );
        if (validHour) {
          this.$swal(
            "No puedes seleccionar este Horario",
            "el horario seleccionado tienen conflicto con otros precios del tarifario",
            "error"
          );
          return false;
        }

        if (!this.Precios[arrayDays.join("-")]) {
          this.Precios[arrayDays.join("-")] = {};
        }

        if (!this.Precios[arrayDays.join("-")][this.tipoJuego]) {
          this.Precios[arrayDays.join("-")][this.tipoJuego] = {};
        }

        this.Precios[arrayDays.join("-")][this.tipoJuego][this.Horario] = {
          PcoCon: parseFloat(this.precioContable),
          PcoVen: parseFloat(this.precio),
          Moneda: this.moneda,
        };

        this.PreciosList = this.generateListPrecio();
        this.$forceUpdate;
      }else{
        this.$swal(
          "Complete la información necesaria para agregar un precio",
          "Verifique la información",
          "error"
        );
      }
    },
    generateListPrecio() {
      let tableHorarios = [];
      let precios = this.Precios;

      let dias = Object.entries(precios);
      dias.forEach((mod) => {
        let modDias = mod[0].split("-");
        let textDias = "";
        modDias.forEach((element) => {
          textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
        });

        let modalidades = Object.entries(mod[1]);
        modalidades.forEach((modalidad) => {
          let idModalidad = modalidad[0];
          let dataModalidad = modalidad[1];
          let horarios = Object.entries(dataModalidad);
          horarios.forEach((precios) => {
            tableHorarios.push({
              textDias: textDias,
              modDias: modDias,
              modalidadId: idModalidad,
              horarioId: precios[0],
              editing:false,
              modalidadNombre: this.$pgsHelper.getById(
                this.tiposJuego,
                "id",
                idModalidad
              ).nombre,
              horarioNombre: this.$pgsHelper.getById(
                this.Horarios,
                "id",
                precios[0]
              ).Nombre,
              ...precios[1],
            });
          });
        });
      });
      return tableHorarios;
    },
    validateHorarios(modalidad, horario, arrayDays) {
      let isSameHour = false;
      this.PreciosList.forEach((element) => {
        if (
          element.modalidadId == modalidad &&
          element.modDias.join("-") == arrayDays.join("-")
        ) {
          let elementHoraData = this.$pgsHelper.getById(
            this.Horarios,
            "id",
            element.horarioId
          );
          let formHoraData = this.$pgsHelper.getById(
            this.Horarios,
            "id",
            horario
          );

          if (
            element.modalidadId == modalidad &&
            element.modDias.join("-") == arrayDays.join("-") &&
            horario == element.horarioId
          ) {
            isSameHour = true;
          }

          if (
            moment(formHoraData.HoraInicio, "HH:mm:ss").isBetween(
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm"),
              moment(elementHoraData.horaTermino, "HH:mm:ss").format("HH:mm")
            )
          ) {
            isSameHour = true;
          }
          if (
            moment(formHoraData.HoraTermino, "HH:mm:ss").isBetween(
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm"),
              moment(elementHoraData.horaTermino, "HH:mm:ss").format("HH:mm")
            )
          ) {
            isSameHour = true;
          }
          if (
            (moment(formHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ==
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ||
              moment(formHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ==
                moment(elementHoraData.horaTermino, "HH:mm:ss").format(
                  "HH:mm"
                )) &&
            (moment(formHoraData.HoraTermino, "HH:mm:ss").format("HH:mm") ==
              moment(elementHoraData.HoraInicio, "HH:mm:ss").format("HH:mm") ||
              moment(formHoraData.HoraTermino, "HH:mm:ss").format("HH:mm") ==
                moment(elementHoraData.horaTermino, "HH:mm:ss").format("HH:mm"))
          ) {
            isSameHour = true;
          }
        }
      });
      return isSameHour;
    },
    checkForm: function (e) {
      let valid = true;
      this.subcategoria = [];
      if(this.cateTarifa != ''){
        this.subcategoria = [this.cateTarifa];
      }

      this.errors = [];

      if (!this.Temporada) {
        this.errors.temporada = "La temporada es requerida";
        valid = false;
      } else {
        this.errors.temporada = false;
      }

      if (this.subcategoria.length == 0) {
        this.errors.Subcategoria = "La Subcategoria es requerida";
        valid = false;
      } else {
        this.errors.Subcategoria = false;
      }

      if (this.accesos.length == 0) {
        this.errors.accesso = "Los accesos es requerido";
        valid = false;
      } else {
        this.errors.accesso = false;
      }
      if (valid) {
        this.$emit("successDataHorario", this.$data);
      }
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder("RVA/Tarifas/" + this.MainDepartamento + "/Modalidades")
      let arrayTipos = Object.entries(data.val());
      var $this = this;
      arrayTipos.forEach((element) => {
        $this.tiposJuego.push({
          id: element[0],
          codigo: element[1]["Codigo"],
          nombre: element[1]["Nombre"],
        });
        this.valor = element[0];
        this.$emit("input", element[0]);
      });
    },
  },
  computed: {
    // initialHour() {
    //   if (this.HoraInicial === "") {
    //     return this.minDate;
    //   } else {
    //     let hour = new moment(this.HoraInicial);
    //     hour.add(10, "minutes");
    //     return hour.format("HH:mm");
    //   }
    // },
  },
  watch: {},
  beforeMount: function () {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
  },
  async mounted() {
    await this.getHorarios();
    await this.getTiposJuego();
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Temporada = this.dataEdit.Temporada;
      this.subcategoria = this.dataEdit.Subcategoria;
      this.cateTarifa = this.dataEdit.Subcategoria[0];
      this.Precios = this.dataEdit.Precios;
      this.Turista = this.dataEdit.Turista;
      this.Color   = this.dataEdit.Color,
      this.modelColor   = this.dataEdit?.Color || "#4895f5" ,
      this.accesos = this.dataEdit.Accesos;
      this.PreciosList = this.generateListPrecio();
    }
  },
};
</script>

<style scoped>
.selectDay {
  background-color: #2185d0 !important;
  color: white;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
